module.exports = __webpack_public_path__ + "static/media/kitchen-1.0e25fe0d.jpg";